import { UserData } from '../interfaces/UserData'
import { setAuthLogin } from '../reducers/authReducer'
import { DispatchType } from '@redux/types'
import info from '@utils/info'
import storage from '@utils/storage'

export default function getUser(dispatch: DispatchType){
    try {
        const localUser = storage.getObject<UserData>('user')
        if(!!localUser && localUser.id) dispatch(setAuthLogin(localUser))
        else throw new Error('User not found')
    } catch (error) {
        info.error('getUser',error)
    }
}